import { Component, OnInit } from '@angular/core';
import { ModalController } from "@ionic/angular";

@Component({
  selector: 'app-info-programacion-didactica-modal',
  templateUrl: './info-programacion-didactica-modal.component.html',
  styleUrls: ['./info-programacion-didactica-modal.component.scss'],
  standalone: false
})
export class InfoProgramacionDidacticaModalComponent implements OnInit {
  checked = false;

  constructor(private modalController: ModalController) {
  }

  ngOnInit() {
  }

  cancel() {
    this.modalController.dismiss();
  }

  submit() {
    this.modalController.dismiss('submit');
  }
}
